import AccessibilityHelper from './../AccessibilityHelper.js';

class TreeNode {
    constructor(nodeEle, parentNode) {
        this._nodeEle = nodeEle;

        if (parentNode) {
            this._inputEle = nodeEle.querySelector('input');
            this._nodeLinkEle = nodeEle.querySelector('[data-node-link]');
            this._nodeHeaderEle = nodeEle.querySelector('[data-node-header]');
            this._backlinkEle = nodeEle.querySelector('[data-backlink]');
            this._parentNode = parentNode;
        }
        this._childrenEle = nodeEle.querySelector('[data-children]');
        this._isMultiSelect = nodeEle.hasAttribute('data-multi-select');
        this._isSingleSelect = !this._isMultiSelect;

        if (this._childrenEle) {
            this._childNodes = [...this._childrenEle.children].map(
                ele => new TreeNode(ele, this)
            );
        }

        if (this._nodeLinkEle) {
            this._nodeLinkEle.addEventListener('click', event =>
                this._handleNodeLinkClick(event)
            );
        }

        if (this._backlinkEle) {
            this._backlinkEle.addEventListener('click', event =>
                this._handleBackLinkClick(event)
            );
        }
    }

    _handleNodeLinkClick(event) {
        this._traverseToChildNode();
        event.stopPropagation();
        this._fireChangeEvent();
    }

    _handleBackLinkClick(event) {
        this._traverseToParentNode();
        event.stopPropagation();
        this._fireChangeEvent();
    }

    _traverseToChildNode() {
        this.expand();
        this._parentNode.setAsParentOf(this);
        this._focusFirstChild();
    }

    _focusFirstChild() {
        if (this._childNodes) {
            const focused = this._childNodes[0].focus();
            if (focused) {
                return;
            }
        }
        AccessibilityHelper.focusFirst(this._backlinkEle);
    }

    focus() {
        return AccessibilityHelper.focusFirst(this._nodeEle);
    }

    _traverseToParentNode() {
        this.collapse();
        this._parentNode.expand();
        AccessibilityHelper.focusFirst(this._nodeLinkEle);
    }

    _fireChangeEvent() {
        const changeEvent = document.createEvent('Event');
        changeEvent.initEvent('change', true, true);
        this._inputEle.dispatchEvent(changeEvent);
    }

    _isNotRoot() {
        return this._parentNode != null;
    }

    expand() {
        if (this._isNotRoot()) {
            this._select();

            if (this._isSingleSelect) {
                this._showNodeHeaderEle();
                this._hideNodeLinkEle();
            }
        }

        this._showChildrenEle();
        this._showChildNodeEles();
    }

    collapse() {
        this._unselect();

        if (this._isSingleSelect) {
            this._hideNodeHeaderEle();
            this._showNodeLinkEle();
        }

        this._collapseChildNodes();
        this._hideChildrenEle();
    }

    setAsParentOf(childNode) {
        if (this._isNotRoot()) {
            this._hideNodeHeaderEle();
        }
        this._hideSiblings(childNode._nodeEle);
    }

    _hideSiblings(nodeEle) {
        this._hideChildNodeEles();
        nodeEle.classList.remove('hidden');
    }

    _showNodeHeaderEle() {
        this._nodeHeaderEle.classList.remove('hidden');
    }

    _hideNodeHeaderEle() {
        this._nodeHeaderEle.classList.add('hidden');
    }

    _showNodeLinkEle() {
        this._nodeLinkEle.classList.remove('hidden');
    }

    _hideNodeLinkEle() {
        this._nodeLinkEle.classList.add('hidden');
    }

    _showChildrenEle() {
        if (this._childrenEle) {
            this._childrenEle.classList.remove('hidden');
        }
    }
    _hideChildrenEle() {
        if (this._childrenEle) {
            this._childrenEle.classList.add('hidden');
        }
    }

    _select() {
        if (this._isSingleSelect) {
            this._inputEle.checked = true;
        }
    }

    _unselect() {
        this._inputEle.checked = false;
    }

    _showChildNodeEles() {
        if (this._childrenEle) {
            [...this._childrenEle.children].forEach(ele =>
                ele.classList.remove('hidden')
            );
        }
    }

    _hideChildNodeEles() {
        if (this._childrenEle) {
            [...this._childrenEle.children].forEach(ele =>
                ele.classList.add('hidden')
            );
        }
    }

    _collapseChildNodes() {
        if (this._childNodes) {
            this._childNodes.forEach(childNode => childNode.collapse());
        }
    }
}

class TaxonomyTreeWidget {
    constructor(rootNodeEle) {
        const parentNode = null;
        this._rootNode = new TreeNode(rootNodeEle, parentNode);
    }

    reset() {
        this._rootNode._collapseChildNodes();
        this._rootNode._showChildNodeEles();
    }
}

export default TaxonomyTreeWidget;



// WEBPACK FOOTER //
// ./lib/search/TaxonomyTreeWidget.js